import {
  MAINTENANCE_STATUS_REQUEST,
  MAINTENANCE_STATUS_SUCCESS,
  MAINTENANCE_STATUS_FAIL,
} from "../constants/settingsConstants";

export const maintenanceStatusReducer = (
  state = { loading: true, maintenanceMode: false, maintenanceMessage: "" },
  action
) => {
  switch (action.type) {
    case MAINTENANCE_STATUS_REQUEST:
      return { ...state, loading: true };
    case MAINTENANCE_STATUS_SUCCESS:
      return {
        loading: false,
        maintenanceMode: action.payload.maintenanceMode,
        maintenanceMessage: action.payload.maintenanceMessage,
        maintenanceSince: action.payload.maintenanceSince,
      };
    case MAINTENANCE_STATUS_FAIL:
      return {
        loading: false,
        maintenanceMode: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
